import {createStore, applyMiddleware, compose} from 'redux';
import identity from 'lodash/identity';
import thunk from 'redux-thunk';

const tools = global.__REDUX_DEVTOOLS_EXTENSION__
  ? global.__REDUX_DEVTOOLS_EXTENSION__()
  : identity;

export default compose(
  applyMiddleware(thunk),
  tools
)(createStore);
